import React, { Component } from 'react';
import { Link, useHistory } from 'react-router-dom';
import VideoBg from 'reactjs-videobg';
import {
  Block,
  Container,
  HomeButtons,
  Video,
  VideoContainer
} from '../styles/HomeStyles';
import homeImage from '../assets/placeholder.png';
import Header from './header/Header';
import sample from '../assets/sample3.mp4';

export default function Login() {
  const history = useHistory();
  const loginPath = '/login/';
  const signupPath = '/signup';
  const dashboardPath = '/dashboard';
  return (
    <div style={{ flex: 1, height: '100%' }}>
      <Header isHome={true} center={true} />
      <div>
        <VideoContainer>
          <VideoBg
            wrapperClass={{ opacity: 0.2 }}
            videoClass={{ opacity: 0.9 }}
            poster={homeImage}
          >
            <VideoBg.Source src={sample} type="video/mp4" />
          </VideoBg>

          <Block>
            <HomeButtons onClick={() => history.push(loginPath)}>
              <span>LOGIN</span>
            </HomeButtons>
          </Block>
          <Block>
            <HomeButtons onClick={() => history.push(signupPath)}>
              <span>SIGN UP</span>
            </HomeButtons>
          </Block>
          {/* <Block>
          <HomeButtons onClick={ 
              () => history.push(dashboardPath)
            }>
              <span>Dashboard</span>
          </HomeButtons>
        </Block> */}
        </VideoContainer>
      </div>
    </div>
  );
}
